import Home from "./pages/Home"
import './App.css'

function App() {
  return (
    <div className="app ">
      {/* <ScrollToTop /> */}
      <Home />
     </div> 
      
   
  );
}

export default App;